export default (state, { payload: { message, variant, secondaryMessages } }) => ({
    ...state,
    open: true,
    message,
    variant,
    secondaryMessages: typeof secondaryMessages === 'undefined' ? null : secondaryMessages,
});
